import { IRequestUploadTokenCommand } from './request-upload-token';

export enum BridgeToCloudCommand {
  Settings = 'settings',
  RequestUploadToken = 'requestUploadToken',
  SyncUploadedImage = 'syncUploadedImage',
  HicapsConnectResponse = 'hicapsConnectResponse',
  SendLogs = 'sendLogs',
  TwainDevices = 'twainDevices',
  RomexisV2ResolvedPatient = 'romexisV2ResolvedPatient',
}

export enum CloudToBridgeCommand {
  GetLogs = 'getLogs',
  GetTwainDevices = 'getTwainDevices',
  /**
   * @deprecated
   * Superseded by the device's RTDB settings node. Still sent
   * for bridges released before that node existed.
   */
  UpdateSettings = 'updateSettings',
  TriggerImageUpload = 'triggerImageUpload',
}

export enum BridgeToCloudJobStatus {
  Pending = 'pending',
  Complete = 'complete',
  Failed = 'failed',
}

export interface IBridgeToCloudJob {
  status: BridgeToCloudJobStatus;
  type: BridgeToCloudCommand;
  data: IRequestUploadTokenCommand;
}
